import React from "react";
import { connect } from "react-redux";
import _ from "lodash";
import PresentingSlidekick from "./SlidekickOnly";
import PresentingSlideKickAndHero from "./SlidekickAndHero";

const Presenting = (props) => {
  const slidekick_only = _.get(props, "gameReducer.roomObj.game_state.slidekick_only");
  return <>{slidekick_only ? <PresentingSlidekick /> : <PresentingSlideKickAndHero />}</>;
};

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
});

export default connect(mapStateToProps)(Presenting);
